import React, { Fragment, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';

import {
  nextAction,
} from 'actions/workflow';

import CircleDeclined from 'assets/icons/circle-declined.svg';
import style from './style.scss';

const DocusignDeclined = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleContinueSignLoanDocument = (e) => {
    e.preventDefault();
    const key = searchParams.get('key');
    if (key) {
      setIsLoading(true);
      dispatch(nextAction({
        data: {},
        url: `/workflows/fsl/${key}/next`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: (error) => {
          navigate('/fsl/general-error-page', {
            state: {
              data: error.data,
            },
          });
        },
      }));
    }
  };

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className="grid-container fluid borrowers-message">
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">

              <Column className="small-12 large-10 large-offset-1">
                <img src={CircleDeclined} alt="circle declined" />
                <h2>Agreement Signature Pending</h2>
                <p className="p-xlarge">{get(props, 'location.data.data.message')}</p>

                {
                  get(location, 'data.data.showCallToActionButton') &&
                    <Button
                      className={cn('button large green w-50', isLoading ? '' : 'arrow')}
                      onClick={handleContinueSignLoanDocument}
                      isLoading={isLoading}
                    >
                      Continue Signing Loan Document
                    </Button>
                }
              </Column>

            </Grid>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default DocusignDeclined;
